module.exports = __webpack_public_path__ + "static/media/verifiedAmber.0d6e8fd8.svg";